import * as React from 'react';
import { cn } from '@/lib/cn';

type SkeletonProps = React.HTMLAttributes<HTMLDivElement> & {
  /**
   * Optional screen-reader announcement. When omitted skeleton is `aria-hidden`.
   * Note: `aria-hidden` is placed after `{...props}` and cannot be overridden by
   * consumers — skeletons are intentionally decorative by default.
   */
  label?: string;
};

export const Skeleton = ({ className, label, ...props }: SkeletonProps) => (
  <div
    className={cn('skeleton rounded-md bg-surface', className)}
    {...props}
    aria-hidden={label ? undefined : true}
  >
    {label && <span className="sr-only">{label}</span>}
  </div>
);
